import React from 'react';
import { Navigate } from 'react-router-dom';
import { clinicAuthService } from '../services/clinicService';

function ClinicPrivateRoute({ children }) {
  const isAuthenticated = clinicAuthService.isAuthenticated();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

export default ClinicPrivateRoute;
